import { render, staticRenderFns } from "./CierreLaGeneral.vue?vue&type=template&id=15a2b420&"
import script from "./CierreLaGeneral.vue?vue&type=script&lang=js&"
export * from "./CierreLaGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports